import $ from "jquery"
import { trace } from "./helpers.js"
// window.jQuery = window.$ = $;
// require('./../../../node_modules/lightgallery.js/dist/js/lightgallery');


const ImageGallery = {
  
  // ### init ###
  init() {
    // trace("init blueimp gallery");
  }

}

export default ImageGallery;